import React from 'react';

import WishListPageSkeleton from '../../components/skeleton/WishListPageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const WISHLIST_PAGE_CHUNK_NAME = 'wishlist';

export const WishListPage = createRouteLoadable(
  () => import(/* webpackChunkName: "wishlist" */ '../../pages/WishListPage'),
  {
    fallback: <WishListPageSkeleton />,
  }
);
